export default __webpack_public_path__ + "static/media/anthem-website-logos_comicrelief.93794cbe.webp";